// reducers/serializeDetailReducer.js
import {
    FETCH_SERIALIZE_DETAIL_REQUEST,
    FETCH_SERIALIZE_DETAIL_SUCCESS,
    FETCH_SERIALIZE_DETAIL_FAILURE,
  } from '../actions/serializeDetailTypes';
  
  const initialState = {
    loadingsd: false,
    students: [],
    error: '',
  };
  
  const serializeDetailReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SERIALIZE_DETAIL_REQUEST:
        return {
          ...state,
          loadingsd: true,
        };
      case FETCH_SERIALIZE_DETAIL_SUCCESS:
        return {
          ...state,
          loadingsd: false,
          students: action.payload,
          error: '',
        };
      case FETCH_SERIALIZE_DETAIL_FAILURE:
        return {
          ...state,
          loadingsd: false,
          students: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default serializeDetailReducer;
  